import { render, staticRenderFns } from "./RecipientResources.vue?vue&type=template&id=3721c0b8&"
import script from "./RecipientResources.vue?vue&type=script&lang=js&"
export * from "./RecipientResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports